import { createRouter, createWebHistory } from 'vue-router';

// import TherapistDetail from './pages/therapists/TherapistDetail.vue';
// import TherapistList from './pages/therapists/TherapistList.vue';
// import TherapistRegistration from './pages/therapists/TherapistRegistration.vue';
// import ContactTherapist from './pages/requests/ContactTherapist.vue';
// import RequestReceived from './pages/requests/RequestReceived.vue';
// import UserAuth from './pages/auth/UserAuth.vue';
// import NotFound from './pages/NotFound.vue';

const TherapistDetail = () => import('./pages/therapists/TherapistDetail.vue');
const TherapistList = () => import('./pages/therapists/TherapistList.vue');
const TherapistRegistration = () => import('./pages/therapists/TherapistRegistration.vue');
const ContactTherapist = () => import('./pages/requests/ContactTherapist.vue');
const RequestReceived = () => import('./pages/requests/RequestReceived.vue');
const UserAuth = () => import('./pages/auth/UserAuth.vue');
const NotFound = () => import('./pages/NotFound.vue'); 

import store from './store/index.js';

const router = createRouter({
    history: createWebHistory(),
    routes:[
        { path: '/', redirect: '/therapist'},
        { path: '/therapist', component: TherapistList},
        { path: '/therapist/:id', 
          component: TherapistDetail,
          props: true,
          children: [
              { path: 'contact', component: ContactTherapist}, // therapist/cl/contact
          ]
        },
        { path: '/register', component: TherapistRegistration, meta: { requiresAuth: true}},
        { path: '/requests', component: RequestReceived,  meta: { requiresAuth: true}},
        { path: '/auth', component: UserAuth, meta: { requiresUnauth: true}},
        { path: '/:notFound(.*)', component: NotFound},
    ]
});

router.beforeEach(function(to, _, next){
    if(to.meta.requiresAuth && !store.getters.isAuthenticated ){
        next('/auth');
    } else if(to.meta.requiresUnauth && store.getters.isAuthenticated){
        next('/therapist');
    } else {
        next();
    }
});

export default router;